module.exports = __webpack_public_path__ + "img/pr-9.50616829.png";